import React, { useState, useEffect } from "react";
import styles from "../../styles/CompanyManagement/Competitors.module.css";
import { FiEdit3 } from "react-icons/fi";
import { getCompany, updateCompany } from "../../utils/api";

const Competitors = ({ companyId }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    competitorsPositioning: "",
    productUniqueness: "",
    Competitorname1: "",
    Competitorlink1: "",
    Competitorname2: "",
    Competitorlink2: "",
    Competitorname3: "",
    Competitorlink3: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!companyId) return;
    setLoading(true);
    setError(null);
    getCompany(companyId)
      .then((company) => {
        const competitors = company.additional_infos?.competitors || {};
        setFormData({
          competitorsPositioning: competitors.competitorsPositioning || "",
          productUniqueness: competitors.productUniqueness || "",
          Competitorname1: competitors.Competitorname1 || "",
          Competitorlink1: competitors.Competitorlink1 || "",
          Competitorname2: competitors.Competitorname2 || "",
          Competitorlink2: competitors.Competitorlink2 || "",
          Competitorname3: competitors.Competitorname3 || "",
          Competitorlink3: competitors.Competitorlink3 || "",
        });
      })
      .catch(() => setError("Failed to load data."))
      .finally(() => setLoading(false));
  }, [companyId]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = async () => {
    if (!companyId) return;
    setLoading(true);
    setError(null);
    try {
      const company = await getCompany(companyId);
      const additional_infos = { ...company.additional_infos };
      additional_infos.competitors = { ...formData };
      await updateCompany(companyId, { 
        company: { 
          additional_infos 
        } 
      });
      setIsEditing(false);
    } catch {
      setError("Failed to save data.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  return (
    <div className="company-management-card">
      <div className={styles.detailsHeader}>
        <span className={styles.detailsHeading}>Competitors</span>
        {!isEditing ? (
          <button className={styles.editBtn} onClick={handleEditClick} disabled={loading}>
            <FiEdit3 /> Edit
          </button>
        ) : (
          <button className={styles.saveBtn} onClick={handleSaveClick} disabled={loading}>
            Save
          </button>
        )}
      </div>
      <div className={styles.separator} />
      {error && <div className={styles.error}>{error}</div>}
      {loading ? (
        <div className={styles.detailsContent}>Loading...</div>
      ) : (
        <div className={styles.detailsContent}>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Competitor 1</span>
            {isEditing ? (
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  type="text"
                  name="Competitorname1"
                  placeholder="Name"
                  value={formData.Competitorname1}
                  onChange={handleChange}
                  style={{ flex: 1 }}
                />
                <input
                  type="text"
                  name="Competitorlink1"
                  placeholder="Link"
                  value={formData.Competitorlink1}
                  onChange={handleChange}
                  style={{ flex: 2 }}
                />
              </div>
            ) : (
              formData.Competitorname1 || formData.Competitorlink1 ? (
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <span>{formData.Competitorname1}</span>
                  {formData.Competitorlink1 && (
                    <a href={formData.Competitorlink1} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 8 }}>
                      Link
                    </a>
                  )}
                </div>
              ) : <span>-</span>
            )}
          </div>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Competitor 2</span>
            {isEditing ? (
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  type="text"
                  name="Competitorname2"
                  placeholder="Name"
                  value={formData.Competitorname2}
                  onChange={handleChange}
                  style={{ flex: 1 }}
                />
                <input
                  type="text"
                  name="Competitorlink2"
                  placeholder="Link"
                  value={formData.Competitorlink2}
                  onChange={handleChange}
                  style={{ flex: 2 }}
                />
              </div>
            ) : (
              formData.Competitorname2 || formData.Competitorlink2 ? (
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <span>{formData.Competitorname2}</span>
                  {formData.Competitorlink2 && (
                    <a href={formData.Competitorlink2} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 8 }}>
                      Link
                    </a>
                  )}
                </div>
              ) : <span>-</span>
            )}
          </div>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Competitor 3</span>
            {isEditing ? (
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  type="text"
                  name="Competitorname3"
                  placeholder="Name"
                  value={formData.Competitorname3}
                  onChange={handleChange}
                  style={{ flex: 1 }}
                />
                <input
                  type="text"
                  name="Competitorlink3"
                  placeholder="Link"
                  value={formData.Competitorlink3}
                  onChange={handleChange}
                  style={{ flex: 2 }}
                />
              </div>
            ) : (
              formData.Competitorname3 || formData.Competitorlink3 ? (
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <span>{formData.Competitorname3}</span>
                  {formData.Competitorlink3 && (
                    <a href={formData.Competitorlink3} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 8 }}>
                      Link
                    </a>
                  )}
                </div>
              ) : <span>-</span>
            )}
          </div>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>How are your competitors positioning themselves?</span>
            {isEditing ? (
              <input
                type="text"
                name="competitorsPositioning"
                value={formData.competitorsPositioning}
                onChange={handleChange}
              />
            ) : (
              <p>{formData.competitorsPositioning}</p>
            )}
          </div>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>How is your product unique?</span>
            {isEditing ? (
              <input
                type="text"
                name="productUniqueness"
                value={formData.productUniqueness}
                onChange={handleChange}
              />
            ) : (
              <p>{formData.productUniqueness}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Competitors;